import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/Footer.module.css';
import logo from '../assets/logo_wide.png'; // Navbarと同じロゴを使用

function Footer() {
    return (
        <footer className={styles.footer}>
            {/* 装飾ライン */}
            <div className={styles.decorativeLine}></div>

            <div className={styles.container}>
                {/* 左カラム: ロゴ & 会社情報 */}
                <div className={styles.columnLeft}>
                    <div className={styles.logoWrapper}>
                        <img src={logo} alt="Parnas Logo" className={styles.logoImage} />
                    </div>
                    <div className={styles.addressBox}>
                        <p>PARNAS Inc.</p>
                        <p>Visual Works Studio</p>
                        {/* <p className={styles.techText}>SYSTEM: ONLINE</p> */}
                    </div>
                </div>

                {/* 中央カラム: サイトマップ */}
                <div className={styles.columnCenter}>
                    <h4 className={styles.columnTitle}>SITEMAP</h4>
                    <nav className={styles.navLinks}>
                        <Link to="/" className={styles.navLink}>TOP</Link>
                        <Link to="/aboutUs" className={styles.navLink}>ABOUT US</Link>
                        <Link to="/work" className={styles.navLink}>WORKS</Link>
                        <Link to="/recruit" className={styles.navLink}>RECRUIT</Link>
                        <Link to="/contact" className={styles.navLink}>CONTACT</Link>
                    </nav>
                </div>

                {/* 右カラム: アクション & ポリシー */}
                <div className={styles.columnRight}>
                    <h4 className={styles.columnTitle}>LEGAL</h4>
                    <nav className={styles.legalLinks}>
                        <Link to="/privacyPolicy" className={styles.legalLink}>PRIVACY POLICY</Link>
                    </nav>
                    <div className={styles.copyrightBox}>
                        <p className={styles.copyright}>© 2024 Parnas inc.</p>
                    </div>
                </div>
            </div>

            {/* コーナー装飾 */}
            <div className={styles.cornerTL}></div>
            <div className={styles.cornerTR}></div>
            <div className={styles.cornerBL}></div>
            <div className={styles.cornerBR}></div>
        </footer>
    );
}

export default Footer;
